import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_2: FaireProductEntity = {
  token: "driftless-studios-2",
  type: "product",
  name: "Heart Love Valentine's Soy Wax Candle - Valentines Gifts",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/bf6be3b34d87c87e3ab13859b8f26af77cee83b3cc1c0029fe3ceb3658a11a4f.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 14.5,
  msrpDollars: 26,
  freeShipping: true,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
